import { render, staticRenderFns } from "./call-direction.vue?vue&type=template&id=1917eb0a&scoped=true"
import script from "./call-direction.vue?vue&type=script&lang=js"
export * from "./call-direction.vue?vue&type=script&lang=js"
import style0 from "./call-direction.vue?vue&type=style&index=0&id=1917eb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1917eb0a",
  null
  
)

export default component.exports